import { On3IconArrowDown } from '@on3/icons';
import clsx from 'clsx';

import styles from './SortableHeader.module.scss';

export const SortableHeader = ({
  children,
  className,
  active = false,
  sortDir,
  onSort,
}: {
  children: React.ReactNode;
  className?: string;
  active?: boolean;
  sortDir?: 'asc' | 'desc';
  onSort?: () => void;
}) => {
  if (!onSort) return <th className={className}>{children}</th>;

  return (
    <th className={clsx(className, styles.component)}>
      <button
        data-active={active}
        data-sortDir={sortDir}
        onClick={onSort}
        type="button"
      >
        {children}
        {active && <On3IconArrowDown className={styles.arrow} />}
      </button>
    </th>
  );
};
